'use client';
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type { StockMapProps } from '../createStockPage';
import { StockMapLoading } from '../stockMapLoading';

// Client-only + lazy (mapbox + recharts run browser-only). ssr:false must live
// in a client component; the cast restores the prop type next/dynamic widens.
const MiataInventoryMap = dynamic(
  () => import('./miataMap').then((m) => m.MiataInventoryMap),
  {
    ssr: false,
    loading: () => <StockMapLoading />,
  },
);

export default MiataInventoryMap as ComponentType<StockMapProps>;
